var map = {
	"./phil2021/Abishek-Sharma.jpg": 658,
	"./phil2021/Ankur-Vora.jpg": 659,
	"./phil2021/Atul-Satija.jpg": 660,
	"./phil2021/Krishnan-Mehta.jpg": 661,
	"./phil2021/Naghma-Mulla.jpg": 662,
	"./phil2021/Peter-Varghese.jpg": 663,
	"./phil2021/Raj-Kumar.jpg": 664,
	"./phil2021/Sara-Kalim.jpg": 665,
	"./phil2021/Vikram-Khanna.jpg": 666,
	"./social2022/jai-patel.jpeg": 667,
	"./social2022/jayesh-parekh.jpeg": 668,
	"./social2022/murali-vullaganti.jpeg": 669,
	"./social2022/raj-narula.jpeg": 670,
	"./social2022/raju-reddy.jpeg": 671,
	"./social2022/sean-languedoc.jpeg": 672,
	"./social2022/soumya-rajan.jpeg": 673,
	"./social2022/sushant-palakurthi-rao.jpeg": 674,
	"./social2022/vani-kola.jpeg": 675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 657;